import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";

const Chat: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", size = 24, ...rest }, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
   <path fillRule="evenodd" clipRule="evenodd" d="M8 19H18C20.2091 19 22 17.2091 22 15V7C22 4.79086 20.2091 3 18 3H6C3.79086 3 2 4.79086 2 7V21L8 19ZM4 18.2251L7.67544 17H18C19.1046 17 20 16.1046 20 15V7C20 5.89543 19.1046 5 18 5H6C4.89543 5 4 5.89543 4 7V18.2251Z" fill={color} />
</svg>);
export default Chat;